var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBreakout = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.47 1H32v7.53h-7.53zm0 11.294H32v7.53h-7.53zm0 11.294H32v7.53h-7.53zM0 1h9.412v30.118H0zm11.731 13.714c.166-.183.452-.177.452-.177h6.475s-1.601-2.053-2.07-2.806-.604-1.368 0-1.905c.603-.536 1.226-.281 1.878.497.652.779 2.772 3.485 3.355 4.214s.65 1.965 0 2.835-2.65 4.043-3.163 4.65c-.514.607-1.123.713-1.732.295-.609-.419-.838-1.187-.338-1.872.5-.684 2.07-3.073 2.07-3.073h-6.475s-.27 0-.46-.312-.151-.612-.151-.612l.007-1.246s-.014-.306.152-.488"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBreakout);
export default ForwardRef;